export type ToastTone = "success" | "error" | "info";

export interface ToastPayload {
  id: string;
  message: string;
  tone: ToastTone;
}

export function notify(message: string, tone: ToastTone = "info"): void {
  window.dispatchEvent(new CustomEvent<ToastPayload>("admin:toast", {
    detail: { id: crypto.randomUUID(), message, tone },
  }));
}
